import { getTableLang } from "../../Utils/Inits/getTableLang";


export function loadAssignmentOverview(){
    $("#assignments-list").DataTable({
        language: getTableLang(),
        dom: "<'row'<'col-sm-12 d-flex align-items-center justify-content-end'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-12'p>>",
        info: false,
        bLengthChange: false,
        paging: true,
        columnDefs: [
            {"orderable": false, "targets": [0,1,4]}
        ],
    })
}